import { useEffect, useState } from "react";
import { useParams, Link } from "wouter";

export default function PublicShare() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`/api/public-share/${token}`)
      .then(async (r) => {
        const body = await r.json();
        if (!r.ok) throw new Error(body.error || "Could not load this link.");
        return body;
      })
      .then(setData)
      .catch((e) => setError(e.message));
  }, [token]);

  const kicker = data?.type === "floor"
    ? "SHARED FLOOR"
    : data?.type === "weekly_review"
    ? "SHARED REVIEW"
    : "CONQUEST";

  return (
    <div className="page">
      <div className="kicker" style={{ marginBottom: 12 }}>
        <span className="the-line" />
        {kicker}
      </div>

      {!data && !error && (
        <p className="empty-state">Loading...</p>
      )}

      {error && <p style={{ color: "var(--error)" }}>{error}</p>}

      {data && data.type === "floor" && (
        <>
          <h1 style={{ marginBottom: 8 }}>His floor</h1>
          <p style={{ color: "var(--muted)", marginBottom: 24 }}>His minimum viable week - shared read-only.</p>
          <div className="card">
            <div className="hairline-list">
              {data.floor.map((f, i) => (
                <div key={i}>
                  <div>{f.label}</div>
                  {f.detail && <div style={{ color: "var(--muted)", fontSize: 13, marginTop: 4 }}>{f.detail}</div>}
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {data && data.type === "weekly_review" && (
        <>
          <h1 style={{ marginBottom: 8 }}>Weekly review</h1>
          <p style={{ color: "var(--muted)", marginBottom: 24 }}>
            Week of {new Date(data.weekOf).toLocaleDateString()} - shared read-only.
          </p>
          <div className="card">
            <div className="hairline-list">
              {data.big3.map((b, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{b.item}</span>
                  {b.percent != null && <span className="mono">{b.percent}%</span>}
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {data && (
        <div style={{ borderTop: "1px solid var(--hairline)", marginTop: 48, paddingTop: 24, paddingBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "center", color: "var(--muted)", fontSize: 13 }}>
          <span>CONQUEST</span>
          <div style={{ display: "flex", gap: 24 }}>
            <Link href="/take-the-diagnostic" style={{ color: "var(--muted)", textDecoration: "none" }}>Take the Standing Check</Link>
            <Link href="/signup?ref=share" style={{ color: "var(--muted)", textDecoration: "none" }}>Sign up</Link>
          </div>
        </div>
      )}
    </div>
  );
}
